import React, { useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { JobForm } from '../components/jobs/JobForm';

export const JobEditPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  // TODO: Replace with Toolpad navigation
  const currentProject = null;
  const [formOpen, setFormOpen] = useState(true);
  
  const jobData = location.state?.job;
  const isNewJob = !id; // If no ID in URL, we're creating a new job

  const handleSuccess = () => {
    // Navigate back to project-aware data management jobs tab
    if (currentProject) {
      navigate(`/projects/${currentProject.id}/data-management?tab=jobs`);
    } else {
      navigate('/projects');
    }
  };

  const handleClose = () => {
    // Navigate back to project-aware data management jobs tab
    if (currentProject) {
      navigate(`/projects/${currentProject.id}/data-management?tab=jobs`);
    } else {
      navigate('/projects');
    }
  };

  // For edit mode, we need job data. For new mode, we don't.
  if (!isNewJob && !jobData) {
    return (
      <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
        <Typography variant="h6" color="error">
          Job data not found. Please navigate from the jobs page.
        </Typography>
        <Button
          startIcon={<ArrowBack />}
          onClick={handleClose}
          variant="outlined"
          sx={{ mt: 2 }}
        >
          Back to Jobs
        </Button>
      </Box>
    );
  }

  if (!currentProject) {
    return (
      <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
        <Typography variant="h6" color="error">
          Please select a project first.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={handleClose}
          variant="outlined"
          size="small"
        >
          Back to Jobs
        </Button>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
          {isNewJob ? 'Add New Job' : `Edit Job: ${jobData?.description || 'New Job'}`}
        </Typography>
      </Box>

      <JobForm
        open={formOpen}
        onClose={handleClose}
        projectId={currentProject.id}
        job={isNewJob ? undefined : jobData}
        onSuccess={handleSuccess}
      />
    </Box>
  );
};